import { Button, Modal, ShareBar } from "@dreambigger/design-system";
import { CloseOutlined } from "@ant-design/icons";
import { memo } from "react";
import { useModalAnalytics } from "@dreambigger/shared/src/hooks";

type Props = {
  visible: boolean;
  onClose: () => void;
  keyword: string;
};

/**
 * A modal that encourages the user to share their project/event page
 * after clicking "Done" on the edit page.
 */
const ShareEncouragementModal = ({ visible, onClose, keyword }: Props) => {
  // Modal - Opened / Modal - Closed GA events (legacy parity). Fires on the
  // visible<->hidden transition only.
  useModalAnalytics(visible, "ShareEncouragementModal");

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={visible}
      closable={true}
      onCancel={handleClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width={400}
      centered
    >
      <div
        className="tc pa-4"
        style={{
          backgroundColor: "#4EBCD4",
          borderRadius: "8px",
          margin: "-24px -24px 0 -24px",
          padding: "24px",
        }}
      >
        <p className="white fwb f-5 mb-2" style={{ lineHeight: "1.4" }}>
          Share your {keyword.toLowerCase()} page now to get friends and family
          involved!
        </p>
        <p className="white f-3 mb-0">
          {keyword}s that share receive{" "}
          <span className="fwb">7x more awareness</span> for their{" "}
          {keyword.toLowerCase()}.
        </p>
      </div>
      <div className="pt-5 pb-3">
        <ShareBar
          labeledButtons={true}
          liftOnHover={true}
          rectangularButtons={false}
          clipboard={false}
        />
      </div>
    </Modal>
  );
};

export default memo(ShareEncouragementModal);
